import { get } from "http";
import React from "react";
import { useQuery } from "react-query";
import { getMailDetails } from "./gateway";

function useGetEmailDetails(filters: { id: string; emailType: string }) {
  return useQuery({
    queryFn: () => getMailDetails(filters.emailType, filters.id),
    queryKey: ["getEmailDetails", filters],
    enabled: Boolean(filters.id) && filters.id !== "undefined",
  });
}

export default useGetEmailDetails;
